import { render, staticRenderFns } from "./creative-config-form-preview.vue?vue&type=template&id=af18d9b2&scoped=true"
import script from "./creative-config-form-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-config-form-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-config-form-preview.vue?vue&type=style&index=0&id=af18d9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af18d9b2",
  null
  
)

export default component.exports